<template>
  <v-dialog
    overlay-color="rgba(0,0,0,0.4)"
    overlay-opacity="0.8"
    v-model="state"
    width="500px"
    persistent
  >
    <ValidationObserver v-slot="{ handleSubmit }">
      <form @submit.prevent="handleSubmit(addProduct)" class="px-3">
        <v-card flat ref="form">
          <v-card-title>
            <span class="font-weight-bold blue-grey--text font-size-lg ft ml-1"
              >Add Product</span
            >
            <v-spacer></v-spacer>
          </v-card-title>
          <v-card-text>
            <v-col>
              <v-row>
                <ValidationProvider
                  tag="div"
                  class="d-flex flex-row flex-grow-1"
                  v-slot="{ errors }"
                  rules="required"
                >
                  <v-text-field
                    outlined
                    autofocus
                    v-model="product.name"
                    label="Name"
                    :error-messages="errors[0]"
                    hint="Name of the product"
                  />
                </ValidationProvider>
              </v-row>
              <v-row>
                <ValidationProvider
                  tag="div"
                  class="d-flex flex-row flex-grow-1"
                  v-slot="{ errors }"
                  rules="required|numeric"
                >
                  <v-text-field
                    outlined
                    autofocus
                    v-model="product.minimumThreshold"
                    label="Minimum threshold"
                    :error-messages="errors[0]"
                    hint="Minimum threshold for the product"
                  />
                </ValidationProvider>
              </v-row>
              <v-row>
                <ValidationProvider
                  tag="div"
                  class="d-flex flex-row flex-grow-1"
                  v-slot="{ errors }"
                  rules="required"
                >
                  <v-text-field
                    outlined
                    autofocus
                    v-model="product.price"
                    label="Product price"
                    :error-messages="errors[0]"
                    hint="Set price for product"
                  />
                </ValidationProvider>
              </v-row>
              <v-row>
                <ValidationProvider
                  tag="div"
                  class="d-flex flex-row flex-grow-1"
                >
                  <v-textarea
                    outlined
                    autofocus
                    v-model="product.description"
                    label="Product description"
                    hint="Description of product"
                  />
                </ValidationProvider>
              </v-row>
            </v-col>
          </v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn class="mr-2 ft text-capitalize" text @click="close">
              Cancel
            </v-btn>
            <v-btn
              color="primary"
              :loading="loading"
              type="submit"
              class="ft white--text text-capitalize"
            >
              Save
            </v-btn>
          </v-card-actions>
        </v-card>
      </form>
    </ValidationObserver>
  </v-dialog>
</template>
<script>
import { ValidationProvider, ValidationObserver, extend } from "vee-validate";
import { numeric, required } from "vee-validate/dist/rules";
import { mapGetters } from "vuex";

extend("required", {
  ...required,
  message: "Field is required"
});
extend("numeric", {
  ...numeric,
  message: "Field accept only numbers"
});
export default {
  name: "NewProductDialog",
  props: {
    state: { type: Boolean, default: false },
    loading: {
      type: Boolean,
      default: false
    },
    progress: {
      type: Boolean,
      default: false
    }
  },
  components: {
    ValidationProvider,
    ValidationObserver
  },
  data: () => ({
    product: {
      name: "",
      description: "",
      minimumThreshold: "",
      price: 0
    }
  }),
  computed: {
    ...mapGetters({
      resetFormState: "getResetFormState",
      resetFormValues: "products/getResetFormValues"
    })
  },
  watch: {
    resetFormState(value) {
      if (value) {
        this.product = { ...this.resetFormValues };
      }
    }
  },
  methods: {
    addProduct() {
      this.$emit("product", {
        loading: { idx: "add", status: false },
        body: this.product
      });
    },
    close() {
      this.$emit("actions", "add");
    }
  }
};
</script>
